import dayjs from 'dayjs';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { getLabelWithTimezoneAbbr } from '../../../helpers';
import { stepValueStyle } from './styles';
import { getTimeIn12HrFormat } from './utils';

type DateTimeStepValueProps = {
  date?: string;
  time?: string;
  timezoneAbbr: string;
  appointmentSlotCount: number;
};

export const DateTimeStepValue = ({
  date = '',
  time = '',
  timezoneAbbr,
  appointmentSlotCount,
}: DateTimeStepValueProps) => {
  const { t } = useTranslation('schedule-quick-fill');
  const hasValue = date || time;

  if (!hasValue) {
    return (
      <div css={stepValueStyle}>
        <Text css={{ fontSize: theme.fontSize(20) }} as='span'>
          {t('Select Date & Time')}
        </Text>
      </div>
    );
  }

  return (
    <div css={stepValueStyle}>
      {appointmentSlotCount > 1 ? (
        <Text weight='bold'>{t('{{count}} Appointment Slots', { count: appointmentSlotCount })}</Text>
      ) : (
        <>
          <Text weight='bold'>{dayjs(date).format('MMMM D, YYYY')}</Text>
          &bull;
          <Text weight='regular' color='subdued'>
            {getLabelWithTimezoneAbbr(getTimeIn12HrFormat(date, time), timezoneAbbr)}
          </Text>
        </>
      )}
    </div>
  );
};
